export default ({ data: { page } }, { market, t }) => {
  if (!page) {
    return {};
  }

  return {
    title: t('meta', 'info.page-title', {
      title: page.title,
    }),
    description: t('meta', 'info.description'),
    canonical: market.domain + page.pathName,
    openGraph: [],
    structuredData: undefined,
    hrefLang: page.hrefLang,
  };
};
